import { TicketProgressStage } from "./types";

export const TicketProgressStageMessages: Record<TicketProgressStage, string> =
  {
    raised: "Ticket raised",
    assigned: "In progress",
    resolved: "Resolved",
  };
